import React from "react";
import useLoyalApplicants from "./useLoyalApplicants";
import LoyalApplicantsView from "./LoyalApplicantsView";

const LoyalApplicants = () => {
  const props = useLoyalApplicants();
  return <LoyalApplicantsView {...props} />;
};

export default LoyalApplicants;
